import { render, staticRenderFns } from "./DashboardLendingByPieChart.vue?vue&type=template&id=05e601f9"
import script from "./DashboardLendingByPieChart.vue?vue&type=script&lang=js"
export * from "./DashboardLendingByPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports